var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcNoProjects = function SvgIcNoProjects(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 68 68"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 34,
    fill: "#F0EFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    d: "M41.099 22.948a1.524 1.524 0 0 1 1.412-1.002h9.659c.736 0 1.255.58 1.17 1.292l-2.486 20.959c-.085.712-.749 1.291-1.485 1.291H18.703c-.736 0-1.255-.579-1.17-1.291l2.1-17.603c.085-.712.749-1.292 1.485-1.292h16.685c1.437 0 2.813-.977 3.296-2.354Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M18.09 44.523h32.042l1.823-21.55H19.913l-1.823 21.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M18.09 44.523h32.042l1.316-21.55H19.912l-1.823 21.55Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M18.09 44.524h32.042l1.098-22.239H19.19l-1.1 22.239Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M18.09 44.524h32.042l.434-22.239H19.188L18.09 44.524Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M18.09 44.523h32.042l.193-22.842H18.283l-.193 22.842Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M18.091 44.523h32.042l-.652-22.408H17.644l.447 22.408Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M18.09 44.524h32.042l-.954-22.239H17.137l.953 22.239Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M18.091 44.523h32.042l-1.51-21.9H16.583l1.51 21.9Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0EFEF",
    d: "M18.09 44.523h32.042l-1.75-21.72H16.34l1.75 21.72Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#63B9E9",
    d: "M34.13 24.313c.023-.603.47-1.026 1.098-1.026h9.658c.737 0 1.45.592 1.582 1.328l3.815 19.558c.145.737-.338 1.328-1.063 1.328H18.556c-.736 0-1.449-.591-1.581-1.328l-3.151-16.13c-.145-.736.338-1.327 1.062-1.327H31.57c1.449 0 2.511-.99 2.56-2.403Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9E1F8",
    d: "M34.13 24.313c.023-.603.47-1.026 1.098-1.026h9.658c.737 0 1.45.592 1.582 1.328l3.815 19.558c.145.737-.338 1.328-1.063 1.328H18.556c-.736 0-1.449-.591-1.581-1.328l-3.151-16.13c-.145-.736.338-1.327 1.062-1.327H31.57c1.449 0 2.511-.99 2.56-2.403Z",
    opacity: 0.2
  })));
};
export default SvgIcNoProjects;